import React from "react";
import {LibraryDTO} from "../../../models/library";
import {useTranslation} from "react-i18next";
import {Box, Container} from "@material-ui/core";
import {Tags} from "../../common/tags";
import {MarkdownRender} from "../../common/markdown";
import {createStyles, makeStyles, Theme} from "@material-ui/core/styles";

interface LibraryInfoProps {
    library: LibraryDTO;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        metaCard: {
            border: "1px solid #E5E7EB",
            borderRadius: "8px",
            padding: theme.spacing(2),
            marginBottom: theme.spacing(2),
            display: "flex",
            gap: theme.spacing(4),
        },
        metaCell: {
            display: "flex",
            flexDirection: "column",
        },
        metaLabel: {
            fontSize: "0.75rem",
            fontWeight: 600,
            textTransform: "uppercase" as const,
            color: "#6B7280",
            marginBottom: theme.spacing(0.5),
        },
        metaValue: {
            fontSize: "0.9375rem",
            color: "#111827",
        },
    })
);

export const LibraryInfo: React.FC<LibraryInfoProps> = (props: LibraryInfoProps) => {
    const classes = useStyles();
    const [t] = useTranslation("libraries");
    return (
        <Container maxWidth="md">
            <Box className={classes.metaCard}>
                <Box className={classes.metaCell}>
                    <span className={classes.metaLabel}>{t("library.version")}</span>
                    <span className={classes.metaValue}>{props.library.version}</span>
                </Box>
                <Box className={classes.metaCell}>
                    <span className={classes.metaLabel}>{t("library.license")}</span>
                    <span className={classes.metaValue}>{props.library.license}</span>
                </Box>
            </Box>
            <MarkdownRender value={props.library.description ?? ""} />
            <Tags tags={props.library.tags} />
        </Container>
    );
};
